/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_JoinedInputs */

const en_mobile_referral_joined = /** @type {(inputs: Mobile_Referral_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined Listening`)
};

const es_mobile_referral_joined = /** @type {(inputs: Mobile_Referral_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se unió a Listening`)
};

/**
* | output |
* | --- |
* | "Joined Listening" |
*
* @param {Mobile_Referral_JoinedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_joined = /** @type {((inputs?: Mobile_Referral_JoinedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_JoinedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_joined(inputs)
	return en_mobile_referral_joined(inputs)
});